import { Location } from 'react-router-dom';

import { isStudentSignedIn } from 'approot/student-class-to-do/student-class-to-do.utils';
import { PRIVATE_CLASS_BASE } from 'global/private-routes.constants';

export function isStudentOnStudentPage(location: Location) {
  return (
    location.pathname.includes(`${PRIVATE_CLASS_BASE}/`) && isStudentSignedIn()
  );
}
